const KEY = "pixyquiz_anon_user";
const GUEST_PSEUDO_KEY = "guest_pseudo";
const GUEST_ID_KEY = "guest_id";


export function saveAnon(anon) {
try {
  localStorage.setItem(KEY, JSON.stringify(anon));
  if (anon?.pseudo) localStorage.setItem(GUEST_PSEUDO_KEY, anon.pseudo);
  if (anon?.guest_id) localStorage.setItem(GUEST_ID_KEY, anon.guest_id);
} catch(e) {}
}


export function getAnon() {
try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch(e) { return null; }
}


export function clearAnon() {
try { localStorage.removeItem(KEY); } catch(e) {}
}

export function clearGuestPseudo() {
try { localStorage.removeItem(GUEST_PSEUDO_KEY); } catch(e) {}
}

export function getGuestPseudo() {
try { return localStorage.getItem(GUEST_PSEUDO_KEY) || ""; } catch(e) { return ""; }
}

export function saveGuestPseudo(pseudo) {
try { if (pseudo) localStorage.setItem(GUEST_PSEUDO_KEY, pseudo); } catch(e) {}
}

export function getGuestId() {
try { return localStorage.getItem(GUEST_ID_KEY) || localStorage.getItem("pixy_uid") || ""; } catch(e) { return ""; }
}

export function clearGuestId() {
  try {
    localStorage.removeItem(GUEST_ID_KEY);
    localStorage.removeItem("pixy_uid");
  } catch (e) {}
}

export function clearGuestIdentity() {
  clearAnon();
  clearGuestPseudo();
  clearGuestId();
}

export function ensureGuestId() {
  let guestId = getGuestId();
  if (guestId) return guestId;

  guestId = `guest-${Math.random().toString(36).substring(2, 12)}`;
  try {
    localStorage.setItem(GUEST_ID_KEY, guestId);
    localStorage.setItem("pixy_uid", guestId);
  } catch (e) {}
  return guestId;
}
